/**
 * Loads the state from localStorage.
 * @returns {object | undefined} The persisted state, or undefined if it doesn't exist.
 */
export const loadState = () => {
	try {
		const serializedState = localStorage.getItem('settingsState');
		if (serializedState === null) {
			return undefined;
		}
		return JSON.parse(serializedState);
	} catch (err) {
		console.error('Could not load state from localStorage', err);
		return undefined;
	}
};

/**
 * Saves the state to localStorage.
 * @param {object} state The state to persist.
 */
export const saveState = state => {
	try {
		const serializedState = JSON.stringify(state);
		localStorage.setItem('settingsState', serializedState);
	} catch (err) {
		console.error('Could not save state to localStorage', err);
	}
};
